import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.addressManagement || initialState;

export const selectCountries = createSelector(
  [selectDomain],
  (state) => state.countries
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectCities = createSelector(
  [selectDomain],
  (state) => state.cities
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectFetchingCountries = createSelector(
  [selectDomain],
  (state) => state.fetchingCountries
);

export const selectFetchingStates = createSelector(
  [selectDomain],
  (state) => state.fetchingStates
);

export const selectFetchingCities = createSelector(
  [selectDomain],
  (state) => state.fetchingCities
);

export const selectAddingAddress = createSelector(
  [selectDomain],
  (state) => state.addingAddress
);

export const selectUpdatingAddress = createSelector(
  [selectDomain],
  (state) => state.updatingAddress
);

export const selectPickupAddress = createSelector(
  [selectDomain],
  (state) => state.pickupAddress
);

export const selectBillingAddress = createSelector(
  [selectDomain],
  (state) => state.billingAddress
);

export const selectPickupAddressCount = createSelector(
  [selectDomain],
  (state) => state.pickupAddressCount
);

export const selectBillingAddressCount = createSelector(
  [selectDomain],
  (state) => state.billingAddressCount
);
